<template>
    <vue-slick-grid
      :initialData="data"
      :height="500"
      :editable="true"
      :explicitColumns="columns"
      :showColumnHeader="true"
      :showHeaderRow= "false"
      :initializeDependentCustomPlugins="initializeDependentCustomPlugins"
      :useRemoteData="true"
      :createPreHeaderPanel="false"
      :showPreHeaderPanel="false"
      :preHeaderPanelHeight="23"
      :autoEdit="true"
      @remote-page-changed="pageChangeHandler"
      @sort="sortHandler"
      ref="vueslickgrid"
    ></vue-slick-grid>
    <!-- :customPlugins="customPlugins"
    :grouping="groupByDuration"-->
</template>

<script>
/* eslint-disable */
import { Data, Editors, Formatters, Controls, Plugins } from "ls-slickgrid-es6";
import VueSlickGrid from "ls-vue-slickgrid";
import ModeManager from "@/assets/js/plugins/slick.modemanager";
// let columns =[
//         new Plugins.CheckboxSelectColumn().getColumnDefinition(),
//         {id: 'title', name: 'Title', field: 'title', maxWidth: 100, minWidth: 80},
//         {id: 'duration', name: 'Duration', field: 'duration', resizable: false, sortable: true},
//         {id: '%', name: '% Complete', field: 'percentComplete', sortable: true},
//         {id: 'start', name: 'Start', field: 'start', width: 300, sortable: true},
//         {id: 'finish', name: 'Finish', field: 'finish', width: 300, sortable: true},
//         {id: 'effort-driven', name: 'Effort Driven', field: 'effortDriven', formatter: Formatters.Checkmark, editor: Editors.Checkbox, sortable: true}
//       ];

let checkboxSelector = new Plugins.CheckboxSelectColumn({
  cssClass: "slick-cell-checkboxsel"
});
let gridMenu;

export default {
  components: { VueSlickGrid },
  data() {
    return {
      //data: this.generateDummyData(),
      data: [],
      columns: [],
      //columns: this.generateColumns(),
      groupByDuration: {
        getter: "duration",
        formatter(g) {
          return (
            "Duration:  " +
            g.value +
            "  <span style='color:green'>(" +
            g.count +
            " items)</span>"
          );
        },
        aggregators: [
          new Data.Aggregators.Avg("percentComplete"),
          new Data.Aggregators.Sum("cost")
        ],
        aggregateCollapsed: false,
        lazyTotalsCalculation: true
      }
      // customPlugins: {
      //   checkboxSelectorPlugin: {
      //     register: true,
      //     plugin: checkboxSelector
      //   },
      //   // gridMenuControl: {
      //   //   register: true,
      //   //   plugin: gridMenu
      //   // }
      // },
      // columnOptions: {
      //   percentComplete: {
      //     editor: Editors.Text,
      //     groupTotalsFormatter(totals, columnDef) {
      //       let val = totals.avg && totals.avg[columnDef.field];
      //       if (val != null) {
      //         return "Avg: " + Math.round(val) + "%";
      //       }
      //       return "";
      //     }
      //   },
      //   cost: {
      //     groupTotalsFormatter(totals, columnDef) {
      //       let val = totals.sum && totals.sum[columnDef.field];
      //       if (val != null) {
      //         return "Total: " + ((Math.round(parseFloat(val)*100)/100));
      //       }
      //       return "";
      //     }
      //   }
      // }
    };
  },
  created() {
    let $vm = this;
    //this.columns =
    this.generateColumns();
    //Alan: You can load the data here
    setTimeout(function() {
      let pageNum = 0;
      let pageSize = 50;
      let totalRows = 500;

      $vm.$refs.vueslickgrid.remotePageNum = 0;
      $vm.$refs.vueslickgrid.remotePageSize = 50;
      $vm.$refs.vueslickgrid.remoteTotalRows = 500;

      //$vm.data =
      let tempData = $vm.getRemoteData(pageSize);
      //$vm.data = $vm.data.concat(tempData);
      $vm.data = tempData;
      //assume get one page out of 10

      //$vm.$refs.vueslickgrid.setData();
    }, 2000);

    //gridMenu = new Controls.GridMenu(this.columns, this.data, this.$refs.vueslickgrid.getOptions );
  },
  methods: {
    generateDummyData() {
      let tempData = [];
      for (let i = 0; i < 500; i++) {
        const d = (tempData[i] = {});

        d.id = i;
        d["title"] = "Task " + i;
        d["description"] =
          "This is a sample task description.\n  It can be multiline";
        d["duration"] = "5 days";
        d["percentComplete"] = Math.round(Math.random() * 100);
        d["start"] = "01/01/2009";
        d["finish"] = "01/05/2009";
        d["effortDriven"] = i % 5 == 0;
      }

      return tempData;
    },
    generateColumns() {
      this.columns = [
        checkboxSelector.getColumnDefinition(),
        {
          id: "title",
          name: "Title",
          field: "title",
          maxWidth: 100,
          minWidth: 80,
        },
        {
          id: "duration",
          name: "Duration",
          field: "duration",
          resizable: false,
          sortable: true,
        },
        {
          id: "%",
          name: "% Complete",
          field: "percentComplete",
          sortable: true,
        },
        {
          id: "start",
          name: "Start",
          field: "start",
          width: 300,
          sortable: true,
        },
        {
          id: "finish",
          name: "Finish",
          field: "finish",
          width: 300,
          sortable: true,

        },
        {
          id: "effort-driven",
          name: "Effort Driven",
          field: "effortDriven",
          formatter: Formatters.Checkmark,
          editor: Editors.Checkbox,
          sortable: true,
        }
      ];

      // for (let i = 1; i < this.columns.length; i++){
      //   this.columns[i].header = {
      //     menu: {
      //       items: [
      //         {
      //           //iconImage: sortASC,
      //           title: 'Sort Ascending',
      //           command: 'sort-asc'
      //         },
      //         {
      //           //iconImage: sortDSC,
      //           title: 'Sort Descending',
      //           command: 'sort-desc'
      //         },
      //         {
      //           title: 'Hide Column',
      //           command: 'hide',
      //           //disabled: true,
      //           tooltip: "Can't hide this column"
      //         },
      //         {
      //           iconCssClass: 'icon-help',
      //           title: 'Help',
      //           command: 'help'
      //         }
      //       ]
      //     }
      //   };
      // }

      //return cols;
    },
    initializeDependentCustomPlugins(slickGridInstance, customPlugins) {
      //console.log(slickGridInstance);
      this.slickGridMenu = new Controls.GridMenu(
        slickGridInstance.getColumns(),
        slickGridInstance,
        slickGridInstance.getOptions()
      );
      customPlugins["gridMenuControl"] = {
        register: true,
        plugin: this.slickGridMenu
      };
      customPlugins["checkboxSelectorPlugin"] = {
        register: true,
        plugin: checkboxSelector
      };
      let modeManager = new ModeManager(
        slickGridInstance.getOptions(),
        //this.$refs.vueslickgrid.$refs["top-button-bar"],
        //this.$refs.vueslickgrid.$refs["bottom-button-bar"],
        //this.$refs.vueslickgrid.dataView,
        //this.$refs.vueslickgrid.$refs.slickModal,
        this.$refs.vueslickgrid,
        this
      );
      customPlugins["modeManager"] = {
        register: true,
        plugin: modeManager
      };
    },
    getRemoteData(pageSize, startIndex = 0) {
      console.log("getRemoteData");
      const data = [];
      for (let i = startIndex; i < pageSize + startIndex; i++) {
        const d = {};
        d.id = i;
        d["title"] = "Task " + i;
        d["description"] =
          "This is a sample task description.\n  It can be multiline";
        d["duration"] = "5 days";
        d["percentComplete"] = Math.round(Math.random() * 100);
        d["start"] = "01/01/2009";
        d["finish"] = "01/05/2009";
        d["effortDriven"] = i % 5 == 0;
        data.push(d);
      }
      return data;
    },
    pageChangeHandler(args) {
      console.log(args);
      let $vm = this;
      setTimeout(function() {
        let tempData = $vm.getRemoteData(
          args.remotePagingInfo.pageSize,
          args.remotePagingInfo.pageSize * args.remotePagingInfo.pageNum
        );

        $vm.data = tempData;

        //$vm.$refs.vueslickgrid.setData();
      }, 500);
    },
    sortHandler() {
      let $vm = this;
      //API call and get the sorted data
      setTimeout(function(e, args) {
        let tempData = $vm.getRemoteData(
          $vm.$refs.vueslickgrid.remotePagingInfo.pageSize,
          $vm.$refs.vueslickgrid.remotePagingInfo.pageSize *
            $vm.$refs.vueslickgrid.remotePagingInfo.pageNum
        );

        $vm.data = tempData;

        //$vm.$refs.vueslickgrid.setData();
      }, 500);
    }
  }
};
</script>
